// PawFresh™ Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {

  // ---- STICKY HEADER SCROLL EFFECT ----
  const header = document.querySelector('.pf-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ---- MOBILE MENU ----
  const hamburger = document.querySelector('.pf-hamburger');
  const mobileMenu = document.querySelector('.pf-mobile-menu');
  const menuClose = document.querySelector('.pf-mobile-menu-close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', function() {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ---- FAQ ACCORDION ----
  const faqItems = document.querySelectorAll('.pf-faq-item');
  faqItems.forEach(function(item) {
    const q = item.querySelector('.pf-faq-q');
    if (q) {
      q.addEventListener('click', function() {
        const isOpen = item.classList.contains('open');
        // Close all
        faqItems.forEach(function(i) { i.classList.remove('open'); });
        // Open this one if it was closed
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    }
  });

  // ---- SCROLL REVEAL ANIMATION ----
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      observer.observe(el);
    });

    document.addEventListener('animationend', function() {}, { passive: true });
    // Use a simple style tag for revealed state
    var style = document.createElement('style');
    style.textContent = '[data-reveal].revealed { opacity: 1 !important; transform: translateY(0) !important; }';
    document.head.appendChild(style);
  }

  // ---- EMAIL CAPTURE ----
  const emailForm = document.querySelector('.pf-email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const input = emailForm.querySelector('.pf-email-input');
      const btn = emailForm.querySelector('.pf-email-submit');
      if (input && input.value.includes('@')) {
        btn.textContent = '✓ Grazie!';
        btn.style.background = '#3DBFA0';
        input.value = '';
        input.placeholder = 'Iscritto con successo!';
        setTimeout(function() {
          btn.textContent = 'Iscriviti';
          btn.style.background = '';
          input.placeholder = 'La tua email...';
        }, 3000);
      }
    });
  }

  // ---- CART BUTTON PULSE ----
  const cartBtn = document.querySelector('.pf-cart-btn');
  if (cartBtn) {
    setTimeout(function() {
      cartBtn.style.animation = 'pfPulse 2.5s ease-in-out 1';
    }, 3000);
  }

});
